export const defaultMilestonesComponentConfig = {
    isMilestonesTooltipEnabled: false
};
//# sourceMappingURL=config.js.map